import { render, staticRenderFns } from "./LayoutLogged.vue?vue&type=template&id=2e8bf178"
import script from "./LayoutLogged.vue?vue&type=script&lang=js"
export * from "./LayoutLogged.vue?vue&type=script&lang=js"
import style0 from "./LayoutLogged.vue?vue&type=style&index=0&id=2e8bf178&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports